// @ts-nocheck
import { createSlice } from '@reduxjs/toolkit';
import * as constants from './constants';
import { TTransactionReducer } from './types';

export const initialState: TTransactionReducer = {};

const slice = createSlice({
	initialState,
	name: 'searchFilters',
	reducers: {
		updateSearchQueries(state, { payload: { searchQueries, tableId } }) {
			return {
				...state,
				[tableId]: searchQueries
			};
		}
	}
});

export default slice;

export const { updateSearchQueries } = slice.actions;
